import qwest from 'qwest';
import Customer from '../models/customer.jsx';

let TruBlueApi = {
  registerCustomer(customer, pools, email) {
    return qwest.post('/TruBlue/RegisterTruBlueCustomer', {
      customerID: customer.id,
      truBlueMemberID: customer.truBlueMemberID,
      pools: pools.map(x => x.toApiFormat()),
      email,
    }).then((xhr, res) => res);
  },

};

export default TruBlueApi;
